import { Navigate, useParams } from 'react-router-dom';

/**
 * ClubEditRedirect - Legacy Route Handler
 * 
 * Redirects /clubs/:slug/edit → /clubs/:slug/settings
 * Uses wrapper component because React Router won't interpolate :slug in Navigate strings
 */
export default function ClubEditRedirect() {
  const { slug } = useParams<{ slug: string }>();
  
  // Dev-only tracking for legacy route usage
  if (import.meta.env.DEV) {
    console.warn('[Legacy Route] /clubs/:slug/edit → /clubs/:slug/settings', { slug });
  }
  
  return <Navigate to={`/clubs/${slug}/settings`} replace />;
}
